import {DemoUserID} from 'app/core/services/demo.service';
import {Dimension} from 'app/features/analytics/features/reports/dimension';
import {FilterMode, FilterValue, ReportFilters, TimeFilterValue} from 'app/features/analytics/service/filter-value.interface';
import {DateDimension, DateFilterInput, FilterDimension, FilterInput} from '../../../../globalTypes';

export interface BoundedFilters {
    apps?: FilterInput;
    users?: FilterInput;
    attributionNetworkHid?: FilterInput;
    attributionCampaignHid?: FilterInput;
    adNetworks?: FilterInput;
}

export function filterValueToFilterInput(filter: FilterValue): FilterInput {
    const isOptionsMode = filter.mode === FilterMode.Include || filter.mode === FilterMode.Exclude || !filter.mode;

    if (!isOptionsMode) {
        return {
            dimension: filter.id as FilterDimension,
            values: [],
            include: filter.mode === FilterMode.Contains,
            searchByString: filter.search || '',
        };
    }

    return {
        dimension: filter.id as FilterDimension,
        values: Array.isArray(filter.value) ? (filter.value as string[]).map(String) : [String(filter.value)],
        include: filter.mode === FilterMode.Include || filter.mode === FilterMode.Contains || !filter.mode,
    };
}

export function filterValueToDateFilterInput(dateFilter: FilterValue | TimeFilterValue): DateFilterInput {
    return {
        dimension: dateFilter.id as unknown as DateDimension,
        from: (dateFilter as TimeFilterValue).from,
        to: (dateFilter as TimeFilterValue).to,
        include: true,
    };
}

export function replaceCurrentUserWithDemo(reportFilters: ReportFilters): ReportFilters {
    if (!reportFilters.isDemo) {
        return reportFilters;
    }

    const filter = reportFilters.filter.filter(f => f.id !== Dimension.User);
    filter.push({
        id: FilterDimension.USER,
        value: [DemoUserID],
        mode: FilterMode.Include,
    });

    return {
        ...reportFilters,
        filter,
    };
}

export function getBoundedFilters(reportFilters: ReportFilters): BoundedFilters {
    reportFilters = replaceCurrentUserWithDemo(reportFilters);
    const boundedFilters = reportFilters.filter
        .filter(
            f =>
                [
                    Dimension.User,
                    Dimension.App,
                    Dimension.attribution_network_hid,
                    Dimension.attribution_campaign_hid,
                    Dimension.AdNetwork,
                ].includes(f.id as any) &&
                Array.isArray(f.value) &&
                f.value.length
        )
        .map(filterValueToFilterInput);
    const apps = boundedFilters.find(f => f.dimension === (Dimension.App as any));
    const users = boundedFilters.find(f => f.dimension === (Dimension.User as any));

    const attributionNetworkHid = boundedFilters.find(f => f.dimension === (Dimension.attribution_network_hid as any));
    const attributionCampaignHid = boundedFilters.find(f => f.dimension === (Dimension.attribution_campaign_hid as any));
    const adNetworks = boundedFilters.find(f => f.dimension === (Dimension.AdNetwork as any));

    return {
        apps,
        users,
        attributionNetworkHid,
        attributionCampaignHid,
        adNetworks,
    };
}
